export default __webpack_public_path__ + "static/media/setkeeper-icon.bba74025.png";